import { Dayts, saveContent } from '@/utils';
import { DownloadTripTableAsCsvInput, TripTableFormatEnum } from '@/models/gen/graphql';
import { TripWithCompletionAndRateSearchRaw, customColumns, formatQueries } from './downloadTripWithCompletionAndRateAsCSV';

import { DATE_INPUT_FORMAT } from '@/constants';
import { DownloadTripTableAsCsvDocument } from '@/api/queries';
import graphApi from '@/api';

const [, runDownloadTripTableAsCSV] = graphApi(DownloadTripTableAsCsvDocument);

export const downloadTripTableAsCSV = async (
  query: Partial<TripWithCompletionAndRateSearchRaw>[],
  format: TripTableFormatEnum
): Promise<string> => {
  const input: DownloadTripTableAsCsvInput = {
    customColumns,
    query: formatQueries(query),
    format,
  };
  const res = await runDownloadTripTableAsCSV({ input });
  const fileName = `Trips-${new Dayts().format(DATE_INPUT_FORMAT)}.csv`;
  const content = res?.downloadTripTableAsCSV?.data || '';
  saveContent(content, fileName);
  return content;
};
